import * as Api from '@ViewModels';
import { QueryClient, useQuery } from '@tanstack/react-query';
import { useUserSession } from '../../models/hooks/appStateHooks';
import { LevStandardQueryMeta } from '../../web/ReactQueryProvider';

const emailQueryKey = (id: string) => ['email/<id>', id] as const;

export function useEmailQuery({
	id,
	impersonationContext,
	meta,
}: {
	id: string;
	impersonationContext?: Api.IImpersonationContext;
	meta?: LevStandardQueryMeta;
}) {
	const userSession = useUserSession();
	return useQuery({
		queryFn: () =>
			userSession.webServiceHelper.callAsync<Api.ICampaign>(
				Api.ImpersonationBroker.composeApiUrl({ urlPath: `email/${encodeURIComponent(id)}`, impersonationContext }),
				'GET'
			),
		queryKey: [...emailQueryKey(id), impersonationContext],
		meta,
	});
}

export function invalidateEmailQuery(queryClient: QueryClient, id: string) {
	return queryClient.invalidateQueries({ queryKey: emailQueryKey(id) });
}
